import { render, staticRenderFns } from "./eliminationListDetails.vue?vue&type=template&id=36360d26&scoped=true&"
import script from "./eliminationListDetails.vue?vue&type=script&lang=js&"
export * from "./eliminationListDetails.vue?vue&type=script&lang=js&"
import style0 from "./eliminationListDetails.vue?vue&type=style&index=0&id=36360d26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36360d26",
  null
  
)

export default component.exports